// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Status } from "./Status";
import { StatusFromJSON, StatusFromJSONTyped, StatusToJSON, StatusToJSONTyped } from "./Status";
import type { TranslatableString } from "./TranslatableString";
import {
  TranslatableStringFromJSON,
  TranslatableStringFromJSONTyped,
  TranslatableStringToJSON,
  TranslatableStringToJSONTyped,
} from "./TranslatableString";

/**
 *
 * @export
 * @interface State
 */
export interface State {
  /**
   *
   */
  id?: Status;
  /**
   *
   */
  progress?: number;
  /**
   *
   */
  message?: string | null;
  /**
   *
   */
  messageI18n?: TranslatableString | null;
}

/**
 * Check if a given object implements the State interface.
 */
export function instanceOfState(value: object): value is State {
  return true;
}

export function StateFromJSON(json: any): State {
  return StateFromJSONTyped(json, false);
}

export function StateFromJSONTyped(json: any, ignoreDiscriminator: boolean): State {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : StatusFromJSON(json["id"]),
    progress: json["progress"] == null ? undefined : json["progress"],
    message:
      json["message"] === undefined ? undefined : json["message"] === null ? null : json["message"],
    messageI18n:
      json["message_i18n"] === undefined
        ? undefined
        : json["message_i18n"] === null
        ? null
        : TranslatableStringFromJSON(json["message_i18n"]),
  };
}

export function StateToJSON(json: any): State {
  return StateToJSONTyped(json, false);
}

export function StateToJSONTyped(value?: State | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    id: StatusToJSON(value["id"]),
    progress: value["progress"],
    message: value["message"],
    message_i18n: TranslatableStringToJSON(value["messageI18n"]),
  };
}
